import { getServiceUrl } from './api.config';
import { ApiClientOptions } from './types/api';
import ApiClient from './utils/ApiClient';
import checkNot from './utils/checkNot';

export default class ClassificationApi extends ApiClient {
  public constructor(options?: ApiClientOptions) {
    super(getServiceUrl('classification'), options);
  }
  // =============================================================================
  //                          PRODUCT CLASSIFICATION APIs
  // =============================================================================

  public ValidateFieldSuggestion(data: any) {
    const route = '/classification/v2/fieldsuggestion/validate';
    return this.post(route, data);
  }

  public EditFieldSuggestion(data: any) {
    const route = '/classification/v2/fieldsuggestion/edit';
    return this.post(route, data);
  }

  public AcceptFieldSuggestion(data: any) {
    const route = '/classification/v3/fieldsuggestion/accept';
    return this.post(route, data);
  }

  public RefuseFieldSuggestion(data: any) {
    const route = '/classification/v3/fieldsuggestion/refuse';
    return this.post(route, data);
  }

  public GetProductSegmentHierarchy(organizationId: number) {
    const query = `/classification/v1/segment/hierarchy`;
    let parameters = '?alk=1';
    if (checkNot(organizationId, ['undefined', 'null', 'empty'])) {
      parameters += `&organization_id=${organizationId}`;
    }
    return this.get(query, parameters);
  }
}
